// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LSR-scoped typography and base styles */
:host {
  display: block;
  font-family: var(--font-main);
}

:host h1,
:host h2,
:host h3,
:host p,
:host ul {
  margin: 0;
}

  :host h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

  :host h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple); 
}  

:host p,
:host ul {
  font-size: 18px;
  line-height: 1.18;  
}  

:host ul {
  max-width: 563px;
  padding-left: 24px;
}

:host li::marker {
  font-size: 10px;
}

:host a {
  color: inherit;
}

:host a.primary-button,
:host a.primary-button:link,
:host a.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

:host a.primary-button:hover,
:host a.primary-button:focus-visible {
  color: var(--color-white);
  text-decoration: none;
}

:host p a {
  color: var(--color-green);
}

:host img {
  display: block;
  max-width: 100%;
  height: auto;
  border: 0;
}

:host section {
  scroll-margin-top: 120px;
} 
  
@media (max-width: 1024px) {
  :host h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
  }
    
}

@media (max-width: 767px) {
  :host h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
  }

  :host h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple); 
  }

  :host p,
  :host ul {
  font-size: 18px;
  line-height: 1.18;  
  }
}
/* CSS for Studylist spacing above */
:host .participant-studies-heading {  
  margin-bottom: 10px; /* applies study list heading spacing */ 
  padding-bottom: 4px;  /* applies study list heading spacing */
  padding-top: 16px;  /* applies study list heading spacing */
}
:host .participant-studies-list { /* applies study list spacing */
  margin-top: 10px; 
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 25px;;
}
/* CSS for Studylist spacing below */
:host .participant-studies-list + .one-columns {
  margin-top: 0;
  padding-top: 16px;  
}  `, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/participant_home/participant_home.component.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;;EAKE,SAAS;AACX;;EAEE;EACA,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;EAEE;EACA,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;EACA,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;;AAEF;;AAEA;EACE;EACA,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;;EAEA;EACA,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B;;EAEA;;EAEA,eAAe;EACf,iBAAiB;EACjB;AACF;AACA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,uCAAuC;EAC5D,mBAAmB,GAAG,uCAAuC;EAC7D,iBAAiB,GAAG,uCAAuC;AAC7D;AACA,kCAAkC,+BAA+B;EAC/D,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/* LSR-scoped typography and base styles */\r\n:host {\r\n  display: block;\r\n  font-family: var(--font-main);\r\n}\r\n\r\n:host h1,\r\n:host h2,\r\n:host h3,\r\n:host p,\r\n:host ul {\r\n  margin: 0;\r\n}\r\n\r\n  :host h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n  :host h2 {\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple); \r\n}  \r\n\r\n:host p,\r\n:host ul {\r\n  font-size: 18px;\r\n  line-height: 1.18;  \r\n}  \r\n\r\n:host ul {\r\n  max-width: 563px;\r\n  padding-left: 24px;\r\n}\r\n\r\n:host li::marker {\r\n  font-size: 10px;\r\n}\r\n\r\n:host a {\r\n  color: inherit;\r\n}\r\n\r\n:host a.primary-button,\r\n:host a.primary-button:link,\r\n:host a.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n:host a.primary-button:hover,\r\n:host a.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n:host p a {\r\n  color: var(--color-green);\r\n}\r\n\r\n:host img {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  border: 0;\r\n}\r\n\r\n:host section {\r\n  scroll-margin-top: 120px;\r\n} \r\n  \r\n@media (max-width: 1024px) {\r\n  :host h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n  }\r\n    \r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :host h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n  }\r\n\r\n  :host h2 {\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple); \r\n  }\r\n\r\n  :host p,\r\n  :host ul {\r\n  font-size: 18px;\r\n  line-height: 1.18;  \r\n  }\r\n}\r\n/* CSS for Studylist spacing above */\r\n:host .participant-studies-heading {  \r\n  margin-bottom: 10px; /* applies study list heading spacing */ \r\n  padding-bottom: 4px;  /* applies study list heading spacing */\r\n  padding-top: 16px;  /* applies study list heading spacing */\r\n}\r\n:host .participant-studies-list { /* applies study list spacing */\r\n  margin-top: 10px; \r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  margin-bottom: 25px;;\r\n}\r\n/* CSS for Studylist spacing below */\r\n:host .participant-studies-list + .one-columns {\r\n  margin-top: 0;\r\n  padding-top: 16px;  \r\n}  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
